import { __decorate } from "tslib";
import { AutoEncoder, BooleanDecoder, DateDecoder, field, IntegerDecoder, StringDecoder } from "@simonbackx/simple-encoding";
import { v4 as uuidv4 } from "uuid";
export class STCredit extends AutoEncoder {
    constructor() {
        super(...arguments);
        /**
         * Credits in cents
         */
        this.change = 0;
        this.allowTransactions = false;
        this.description = "";
        this.createdAt = new Date();
        this.expireAt = null;
    }
    static getBalance(credits) {
        var _a;
        return (_a = credits.slice().reverse().reduce((t, c) => {
            if (c.expireAt !== null && c.expireAt < new Date()) {
                return t;
            }
            const l = t + c.change;
            if (l < 0) {
                return 0;
            }
            return l;
        }, 0)) !== null && _a !== void 0 ? _a : 0;
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], STCredit.prototype, "id", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], STCredit.prototype, "change", void 0);
__decorate([
    field({ decoder: BooleanDecoder, optional: true })
], STCredit.prototype, "allowTransactions", void 0);
__decorate([
    field({ decoder: StringDecoder })
], STCredit.prototype, "description", void 0);
__decorate([
    field({ decoder: DateDecoder })
], STCredit.prototype, "createdAt", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], STCredit.prototype, "expireAt", void 0);
//# sourceMappingURL=STCredit.js.map